// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles.scss
// module id = 1145
// module chunks = 0